import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import ProductHelper from 'src/app/helpers/product-helper';
import Board from 'src/app/model/product/board/board';
import Product from 'src/app/model/product/product';
import { SubProject } from 'src/app/model/project/sub-project';
import { ProjectsTableComponent } from '../projects-table/projects-table.component';

@Component({
  selector: 'rejected-quotation-projects',
  templateUrl: '../projects-table/projects-table.component.html',
  styleUrls: ['../projects-table/projects-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RejectedQuotationProjectsComponent extends ProjectsTableComponent {
  ngOnInit() {
    super.ngOnInit();
    this.projects = [];
    this.displayedColumns = [
      'project_id',
      'quotation.disapprovalRegistration.date',
      'requestor',
      'company',
      'quotation.disapprovalReasons',
      'detailedProductType',
      'productSize',
      'boardTypeAndPlacement',
      'displayStatus',
      'star'
    ];
  }

  protected getLocalStorageKey(): string {
    return 'RejectedQuotationProjectsComponent';
  }

  protected getStatusFilter(): string {
    return 'status/Afgekeurd';
  }

  public getPageTitle(): string {
    return 'Afgekeurde offertes';
  }

  // Override
  public getDefaultSort(): string {
    return 'quotation.disapprovalRegistration.date';
  }

  // Override
  public getDefaultSortDirection(): string {
    return 'desc';
  }

  // Override
  protected preProcessProjects(projects: SubProject[]): void {
    if (projects == null) {
      return;
    }

    super.preProcessProjects(projects);
    projects.forEach(proj => {
      if (
        proj.project != null &&
        CollectionHelper.isPopulated(proj.project.products)
      ) {
        proj.project.products.forEach(p => this.preprocessProduct(p));
      }
    });
  }

  private preprocessProduct(product: Product) {
    if (ProductHelper.isBoard(product)) {
      ProductHelper.calculateTableBoardDisplay(<Board>product);
    }
  }
}
